<template>
  <div>
    <el-tree
      :data="treeData"
      show-checkbox
      :default-expanded-keys="defCheckKeys"
      node-key="id"
      ref="tree"
      highlight-current
      :props="defaultProps"
    ></el-tree>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
export default {
  created() {
    this.treeData = this.setDisabled(this.getAreaValue || [], true);
  },
  mounted() {
    this.treeData = this.setDisabled(this.treeData, false);
    this.$nextTick(() => {
      this.setCheckedKeys();
      this.treeData = this.setDisabled(this.treeData, true);
    });
  },
  methods: {
    setDisabled(data, flag) {
      data.forEach((item) => {
        item.disabled = flag;
        if (item.children) {
          this.setDisabled(item.children, flag);
        }
      });
      return data;
    },
    setCheckedKeys() {
      this.$refs.tree.setCheckedKeys(this.defCheckKeys);
    }
  },
  computed: {
    ...mapGetters("areaTree", ["getAreaValue"])
  },
  watch: {
    defCheckKeys: {
      handler() {
        this.treeData = this.setDisabled(this.treeData, false);
        this.$nextTick(() => {
          this.setCheckedKeys();
          this.treeData = this.setDisabled(this.treeData, true);
        });
      },
      immediate: false,
      deep: true
    }
  },
  props: {
    // 默认选中的城市id
    defCheckKeys: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  data() {
    return {
      treeData: [],
      defaultProps: {
        id: "id",
        label: "areaName",
        children: "children"
      }
    };
  }
};
</script>
